const SaveActiveIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2.5 2C2.5 1.46957 2.69315 0.960859 3.03697 0.585786C3.38079 0.210714 3.8471 0 4.33333 0L11.6667 0C12.1529 0 12.6192 0.210714 12.963 0.585786C13.3068 0.960859 13.5 1.46957 13.5 2V15.5C13.5 15.5904 13.4774 15.6792 13.4348 15.7568C13.3922 15.8343 13.3311 15.8979 13.258 15.9405C13.1849 15.9832 13.1026 16.0035 13.0198 15.9992C12.937 15.9948 12.8568 15.9661 12.7878 15.916L8 13.101L3.21225 15.916C3.14323 15.9661 3.06304 15.9948 2.98023 15.9992C2.89742 16.0035 2.81509 15.9832 2.742 15.9405C2.66891 15.8979 2.6078 15.8343 2.56519 15.7568C2.52257 15.6792 2.50004 15.5904 2.5 15.5V2Z"
      fill="currentColor"
    />
  </svg>
)

export default SaveActiveIcon
